<!--
     <HoritzontalScrollable>
       <template v-slot:content>
         <div>a</div>
         <div>b</div>
       </template>
     </HoritzontalScrollable>

     Properties:
       - no_dragscroll

     Public methods:
       - update() // Update properties because the content has changed
-->

<template>
  <div class="hs-cont">
    <div class="hs-arrow left" v-if="show_arrows" key="nm_left_arrow">
      <v-btn icon @click="scroll(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <div
      :class="'hs-scrollable' + (show_arrows ? ' overflowing' : '')"
      ref="hscont"
      key="scrollable"
    >
      <slot
        name="content"
      />
    </div>

    <div class="hs-arrow right" v-if="show_arrows" key="nm_right_arrow">
      <v-btn icon @click="scroll(1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss">
 .hs-cont {
   display: flex;
   flex-direction: row;
   justify-content: flex-start;
   align-content: flex-start;
   align-items: center;
   overflow-x: hidden;
   overflow-y: hidden;
   width: 100%;
   height: 100%;
 }

 .hs-scrollable {
   display: flex;
   flex-wrap: wrap;
   flex-direction: column;
   justify-content: flex-start;
   align-content: flex-start;
   width: 100%;
   height: 100%;
   overflow-x: auto;
   overflow-y: hidden;
   scrollbar-width: none; /* Firefox */
   -ms-overflow-style: none;  /* IE 10+ */
 }

 .hs-scrollable::-webkit-scrollbar {
   background: transparent; /* Chrome/Safari/Webkit */
   width: 0px;
 }

 .hs-scrollable.overflowing {
   box-shadow: inset -5px 0 10px -10px #00000088,
   inset 5px 0 10px -10px #00000088;
 }

 .hs-arrow {
   display: flex;
   align-items: center;
   position: relative;
   top: 0;
 }

 .hs-arrow.left {
   left: 0;
 }

 .hs-arrow.right {
   right: 0;
 }
</style>

<script>
 import DragScroll from '@/utils/DragScroll';

 function is_element_overflowing_x(elem) {
   return elem.scrollWidth > elem.clientWidth;
 }

 export default {
   name: "HoritzontalScrollable",

   data: () => ({
     show_arrows: false,
     drag_scroll: null,
   }),

   props: {
     no_dragscroll: {type: Boolean, default: false},
   },

   mounted() {
     this.check_show_arrows();
     const elem = this.$refs.hscont;
     setTimeout(() => this.check_show_arrows(), 300);
     window.addEventListener('resize', this.on_resize, true);
     if (!this.no_dragscroll)
       this.drag_scroll = new DragScroll(elem, "x");
   },

   beforeDestroy() {
     const elem = this.$refs.hscont;
     window.removeEventListener('resize', this.on_resize);
     this.drag_scroll.uninstall();
   },

   methods: {
     scroll(dir) {
       const cont = this.$refs.hscont;
       cont.scrollBy({
         top: 0,
         left: 300 * dir,
         behavior: "smooth", // auto, smooth, instant
       });
     },

     check_show_arrows() {
       // Checks if arrows need to be shown, and shows or hides them.
       const elem = this.$refs.hscont;
       this.show_arrows = elem && is_element_overflowing_x(elem);
     },

     on_resize() {
       this.check_show_arrows();
     },

     update() {
       this.check_show_arrows();
     },
   },
 };
</script>
